export type GuidelineType = "aetna" | "nccn";

export function determineGuidelineType(insuranceType: string): GuidelineType {
  if (!insuranceType) return "nccn";

  const lowerInsurance = insuranceType.toLowerCase();
  if (lowerInsurance.includes("aetna")) {
    return "aetna";
  }
  return "nccn";
}

export function getGuidelineUrl(
  type: GuidelineType,
  facilityName?: string,
): string {
  const urls = {
    nccn: "https://firebasestorage.googleapis.com/v0/b/prior--backen-prod-svc-u4g8.appspot.com/o/nccn_guidelines%2FJ9217_NCCN_DrugCompendium.pdf?alt=media&token=63e9c831-c650-468d-bc68-97c0fa0d6413",
    aetna:
      "https://firebasestorage.googleapis.com/v0/b/prior--backen-prod-svc-u4g8.appspot.com/o/nch%2Fscreenshots%2FDemo%20Facility%2FaetnaCTguidline.pdf?alt=media&token=bd6144af-f844-415d-ab4a-16db7082e453",
  };

  // For Demo Hospital/Facility, always use Aetna guidelines
  if (facilityName?.toLowerCase().includes("demo")) {
    return urls.aetna;
  }

  return urls[type];
}

export function getGuidelineButtonText(_type?: GuidelineType): string {
  return "View Guidelines";
}
